import { WebsitePlugin } from '@gift/types/WebsitePlugin';
import { BasicDesignerUi } from './BasicDesignerUi';
import { BasicPreviewUi } from './BasicPreviewUi';
import { renderThumbnail } from './renderThumbnail';
import { BasicSceneOptions } from '@gift/basic-scene-core/BasicSceneOptions';
import { BasicVariantOptions } from '@gift/basic-scene-core/BasicVariantOptions';
import { BasicSceneMeta } from '@gift/basic-scene-core/BasicSceneMeta';

export const basicWebsitePlugin: WebsitePlugin.Scene<
    BasicSceneOptions,
    BasicVariantOptions,
    BasicSceneMeta
> = {
    pluginId: 'basic',
    DesignerUi: BasicDesignerUi,
    PreviewUi: BasicPreviewUi,
    renderThumbnail: renderThumbnail
};